import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import {
  Body,
  H6,
  Stack,
  useTheme,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import { StandardPageContainer } from '~/styles/BaseStyledComponents';

const LOTTIE_SRC = '/lottie_loading.json';

export const SvcOnboardingAuthLoadingScreen = () => {
  const theme = useTheme();
  const t = useTranslate();
  const { isDesktop } = useWindowProperties();

  return (
    <StandardPageContainer
      $background={theme.fn.themeColor('neutral.12')}
      style={{
        justifyContent: 'center',
      }}
    >
      <Stack
        align="center"
        spacing="sm"
        p="70px 32px"
        w={'600px'}
        h={'694px'}
        bg={'Container/Option_2_(White)'}
        maw={'80%'}
        mah={'80%'}
        justify="space-between"
        style={{ overflow: 'auto' }}
      >
        <H6 color="Text/Headlines_(Brand)">
          {t('SvcOnboardingAuth.LoadingTitle')}
        </H6>
        <DotLottieReact
          style={{
            width: isDesktop ? '280px' : '160px',
            height: isDesktop ? '280px' : '160px',
          }}
          src={LOTTIE_SRC}
          loop
          autoplay
        />
        <Body size="lg" color="Text/Secondary">
          {t('SvcOnboardingAuth.LoadingSubtitle')}
        </Body>
      </Stack>
    </StandardPageContainer>
  );
};
